export default function CertificateCoversheetIco() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="3.75" fill="#EBE1F9" />
      <g clip-path="url(#clip0_10389_40706)">
        <path
          d="M15.9997 10.666C17.4724 10.666 18.6663 11.8599 18.6663 13.3327C18.6663 14.0089 18.4146 14.6265 17.9997 15.0965V17.8915C17.9997 18.4366 17.426 18.7912 16.9384 18.5474L15.9997 18.078L15.0609 18.5474C14.5733 18.7912 13.9997 18.4366 13.9997 17.8915V15.0965C13.5847 14.6265 13.333 14.0089 13.333 13.3327C13.333 11.8599 14.5269 10.666 15.9997 10.666ZM17.333 6.66602C18.0694 6.66602 18.6663 7.26297 18.6663 7.99935V9.33268C18.6663 9.70087 18.3679 9.99935 17.9997 9.99935C17.6315 9.99935 17.333 9.70087 17.333 9.33268V7.99935H6.66634V15.9993H11.9997C12.3679 15.9993 12.6663 16.2978 12.6663 16.666C12.6663 17.0342 12.3679 17.3327 11.9997 17.3327H6.66634C5.92996 17.3327 5.33301 16.7357 5.33301 15.9993V7.99935C5.33301 7.26297 5.92996 6.66602 6.66634 6.66602H17.333ZM16.6663 15.9153C16.4533 15.9701 16.2299 15.9993 15.9997 15.9993C15.7695 15.9993 15.5461 15.9701 15.333 15.9153V16.9207L15.7015 16.7364C15.8892 16.6425 16.1101 16.6425 16.2978 16.7364L16.6663 16.9207V15.9153ZM15.9997 11.9993C15.2633 11.9993 14.6663 12.5963 14.6663 13.3327C14.6663 14.0691 15.2633 14.666 15.9997 14.666C16.7361 14.666 17.333 14.0691 17.333 13.3327C17.333 12.5963 16.7361 11.9993 15.9997 11.9993ZM9.99967 12.666C10.3679 12.666 10.6663 12.9645 10.6663 13.3327C10.6663 13.6746 10.409 13.9564 10.0774 13.9949L9.99967 13.9993H8.66634C8.29815 13.9993 7.99967 13.7009 7.99967 13.3327C7.99967 12.9908 8.25704 12.709 8.58859 12.6705L8.66634 12.666H9.99967ZM12.6663 9.99935C13.0345 9.99935 13.333 10.2978 13.333 10.666C13.333 11.0342 13.0345 11.3327 12.6663 11.3327H8.66634C8.29815 11.3327 7.99967 11.0342 7.99967 10.666C7.99967 10.2978 8.29815 9.99935 8.66634 9.99935H12.6663Z"
          fill="#7F56D9"
          stroke="#7F56D9"
          stroke-width="0.2"
        />
      </g>
      <defs>
        <clipPath id="clip0_10389_40706">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(4 4)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
